export default __webpack_public_path__ + "static/media/maths-card.c6f4d85d.webp";